/**
 * MembershipCard.js — Halleck Vineyard membership card.
 *
 * OVERRIDES: src/components/base/MembershipCard.js
 * REASON: Halleck memberships have no cover image and no theme.card_logo_url, so
 *   the base card renders a blank head. The live card shows the winery logo there.
 *   This thin override reuses the base DOM and, only when the head ended up empty,
 *   drops in the header logo (theme.header_icon_url) — the same lockup shown in
 *   the widget header. Halleck-scoped so the shared base stays tenant-agnostic.
 *
 * INTERFACE: render(club) → HTMLElement, identical signature to base.
 */

import BaseMembershipCard from "../../../components/base/MembershipCard.js";
import { getTheme } from "../../../core/configAccessors.js";
import { emit } from "../../../core/state.js";

export default class HalleckMembershipCard extends BaseMembershipCard {
  render(club) {
    const card = super.render(club);

    const head = card.querySelector(".ws-card-head");
    const price_unit = club?.price_unit;
    // Base already added an <img> if there was a cover or card_logo_url. Only
    // fill an otherwise-empty head with the header logo.
    if (head && !head.querySelector("img")) {
      const logo = getTheme("header_icon_url");
      if (logo) {
        const img = document.createElement("img");
        img.className = "ws-card-img ws-rich-mem-logo";
        img.src = logo;
        img.alt = club.title || "Membership";
        img.loading = "lazy";
        img.style.cursor = "pointer";
        const label = club.message || `Tell me more about ${club.title || "this membership"}`;
        img.addEventListener("click", () =>
          emit("ws-prompt-select", { label, value: label, uniqueId: club.unique_id }));
        head.appendChild(img);
      }
    }
    return card;
  }
}
